document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(pointer: fine)').matches) {
    const container = document.querySelector('.thumbnail-list');

    if (!container) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let animationFrameId;

    container.addEventListener('mousedown', (e) => {
      isDown = true;
      container.classList.add('active');
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    });

    container.addEventListener('mouseleave', () => {
      isDown = false;
      container.classList.remove('active');
      cancelAnimationFrame(animationFrameId);
    });

    container.addEventListener('mouseup', () => {
      isDown = false;
      container.classList.remove('active');
      cancelAnimationFrame(animationFrameId);
    });

    container.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;

      const smoothScroll = () => {
        container.scrollLeft = scrollLeft - walk;
        animationFrameId = requestAnimationFrame(smoothScroll);
      };

      cancelAnimationFrame(animationFrameId);
      smoothScroll();
    });
  }
});